export enum OrderType {
  Buy = 0,
  Sell = 1
}

export enum OrderTypesPrimary {
  Buy = 'compra',
  Sell = 'venda'
}

export enum OrderTypesSecondary {
  Buy = 'Comprar',
  Sell = 'Vender'
}

export enum OrderErrors {
  BuyMessage = 'Você não possui saldo suficiente para esta compra',
  SellMessage = 'Você não possui esta quantidade de ativos'
}
